import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { PAYMENT_OPTIONS } from 'constants/payment'
import { floatify } from 'lib/maths/mathUtils'
import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/isSpoofed'
import getDepositAmountBeforeCreditApplied from './getDepositAmountBeforeCreditApplied'
import getCreditBalanceForCheckoutCurrency from 'checkout/selectors/payment/getCreditBalanceForCheckoutCurrency'
import getDepositServiceFee from './getDepositServiceFee'
import getMerchantFeeAmount from '../getMerchantFeeAmount'
import getGiftCardPayAmount from '../getGiftCardPayAmount'

const getDepositAmount = createSelector(
  (state: App.State) => getDepositAmountBeforeCreditApplied(state),
  (state: App.State) => getDepositServiceFee(state),
  (state: App.State) => isSpoofed(state),
  (state: App.State) => state.checkout.payment.rebookingID,
  (state: App.State) => state.checkout.payment.useCredit,
  (state: App.State) => getCreditBalanceForCheckoutCurrency(state),
  (state: App.State) => getMerchantFeeAmount(state, PAYMENT_OPTIONS.DEPOSIT),
  (state: App.State) => getGiftCardPayAmount(state),
  (state: App.State) => state.checkout.payment.useGiftCard,
  (
    depositAmountBeforeCreditApplied,
    serviceFee,
    isSpoofed,
    rebookingID,
    useLECredits,
    creditBalance,
    merchantFee,
    giftCardAmount,
    useGiftCard,
  ): number => {
    const depositServiceFeePayable = isAgentHubEnabled ? 0 : serviceFee
    let depositTotal = depositAmountBeforeCreditApplied + depositServiceFeePayable + merchantFee

    // Apply credits when applicable
    if (isSpoofed && rebookingID && useLECredits) {
      depositTotal = creditBalance < depositTotal ? depositTotal - creditBalance : 0
    }

    // Apply gift card amount to deposit when applicable
    if (isSpoofed && rebookingID && useGiftCard && giftCardAmount > 0) {
      depositTotal = giftCardAmount < depositTotal ? depositTotal - giftCardAmount : 0
    }

    return floatify(depositTotal)
  },
)

export default getDepositAmount
